"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var baseUrl_1 = require("../baseUrl");
var BaseWidgetController = /** @class */ (function () {
    function BaseWidgetController(controllerConfig) {
        var _this = this;
        this.controllerConfig = controllerConfig;
        this.state = {};
        this.promptLogin = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.controllerConfig.wixCodeApi.user.promptLogin({
                                lang: this.controllerConfig.wixCodeApi.site.language,
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        // TODO: handle error
                        console.error(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.currentUser = this.controllerConfig.wixCodeApi.user.currentUser;
    }
    BaseWidgetController.prototype.setState = function (props) {
        this.state = tslib_1.__assign({}, this.state, props);
        this.controllerConfig.setProps(props);
    };
    BaseWidgetController.prototype.getState = function () {
        return this.state;
    };
    BaseWidgetController.prototype.updateConfig = function ($w, updatedConfig) { };
    BaseWidgetController.prototype.getCurrentUser = function () {
        return this.controllerConfig.wixCodeApi.user.currentUser;
    };
    BaseWidgetController.prototype.isUserLoggedIn = function () {
        return this.getCurrentUser().loggedIn;
    };
    BaseWidgetController.prototype.getSiteToken = function () {
        return this.controllerConfig.appParams.instance;
    };
    BaseWidgetController.prototype.getBaseUrls = function () {
        return this.controllerConfig.appParams.baseUrls;
    };
    BaseWidgetController.prototype.getLocale = function () {
        return this.controllerConfig.wixCodeApi.window.locale || 'en';
    };
    BaseWidgetController.prototype.getSiteLanguage = function () {
        return this.controllerConfig.wixCodeApi.site.language || 'en';
    };
    BaseWidgetController.prototype.getApiBaseUrl = function () {
        return baseUrl_1.default(this.controllerConfig.wixCodeApi);
    };
    BaseWidgetController.prototype.getLocation = function () {
        return this.controllerConfig.wixCodeApi.location;
    };
    BaseWidgetController.prototype.onUserLogin = function (callback) {
        var _this = this;
        this.controllerConfig.wixCodeApi.user.onLogin(function (user) {
            _this.currentUser = user;
            callback(user);
        });
    };
    BaseWidgetController.prototype.isEditorMode = function () {
        var viewMode = this.controllerConfig.wixCodeApi.window.viewMode;
        //TODO: now Preview is OOI. WILL BREAK
        return ['Editor', 'Preview'].includes(viewMode);
    };
    BaseWidgetController.prototype.getInitialProps = function () {
        // Props for SSR
        return Promise.resolve({});
    };
    return BaseWidgetController;
}());
exports.BaseWidgetController = BaseWidgetController;
//# sourceMappingURL=BaseWidgetController.js.map